import _ from "lodash";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import DropDown from "../../../Subcomponents/DropDown";
import cssClasses from "../AllAllotments.module.css";

const AllotmentSortFilter = ({
  allCrmAllotments,
  setAllCrmAllotments,
  filterBy,
  setFilterBy,
}) => {
  const [listsOrder, setListsOrder] = useState([
    "Name Ascending",
    "Name Descending",
    "Oldest First",
    "Latest First",
    "Unit No Ascending",
    "Unit No Descending",
  ]);

  useEffect(() => {
    if (filterBy === "Name Ascending") {
      const payload = _.sortBy(
        allCrmAllotments,
        (e) => e.allotmentPaymentId?.leadId?.personId?.name
      );
      setAllCrmAllotments(payload);
    }

    if (filterBy === "Unit No Ascending") {
      const payload = _.sortBy(allCrmAllotments, (e) =>
        Number(e.allotmentPaymentId?.unitId?.unitNo)
      );
      setAllCrmAllotments(payload);
    }

    if (filterBy === "Unit No Descending") {
      const payload = _.sortBy(allCrmAllotments, (e) =>
        Number(e.allotmentPaymentId?.unitId?.unitNo)
      ).reverse();
      setAllCrmAllotments(payload);
    }

    if (filterBy === "Name Descending") {
      const payload = _.sortBy(
        allCrmAllotments,
        (e) => e.allotmentPaymentId?.leadId?.personId?.name
      ).reverse();
      setAllCrmAllotments(payload);
    }

    if (filterBy === "Latest First") {
      const payload = _.sortBy(allCrmAllotments, [
        function (item) {
          return new Date(item.allotmentPaymentId?.created_at).getTime();
        },
      ]).reverse();
      setAllCrmAllotments(payload);
    }

    if (filterBy === "Oldest First") {
      const payload = _.sortBy(allCrmAllotments, [
        function (item) {
          return new Date(item.allotmentPaymentId?.created_at).getTime();
        },
      ]);
      setAllCrmAllotments(payload);
    }
  }, [filterBy]);

  const filterAllotmentBySort = (e) => {
    setFilterBy(e);
  };

  return (
    <div className={cssClasses.filterSortWrapper}>
      <div className={cssClasses.label} style={{ marginBottom: "0px" }}>
        <p style={{ margin: "4px 0", fontSize: "1.6rem" }}>Sort by</p>
      </div>
      <div className={cssClasses.dropdownWrapper}>
        <DropDown
          onChangeSelect={(e) => {
            filterAllotmentBySort(e);
          }}
          selectedValue={filterBy}
          style={{ selectedColor: "#175CD3", background: "#E8F0FE" }}
          list={listsOrder}
        />
      </div>
    </div>
  );
};

export default AllotmentSortFilter;
